import { render, staticRenderFns } from "./ColoringLegend.vue?vue&type=template&id=9e10901e&scoped=true"
import script from "./ColoringLegend.vue?vue&type=script&lang=js"
export * from "./ColoringLegend.vue?vue&type=script&lang=js"
import style0 from "./ColoringLegend.vue?vue&type=style&index=0&id=9e10901e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e10901e",
  null
  
)

export default component.exports